<div class="container">
    <h5>Files Shared with You</h5>
    <i>Maximum file size: 40 MB</i>
    <mat-table #sharedFilesSort="matSort" [dataSource]="sharedFilesDataSource" matSort matSortActive="upload_date"
        matSortDirection="desc" class="mat-elevation-z8 received-files-table">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef class="mat-column-select"></mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-select">
                <mat-checkbox (change)="toggleFileSelection(element)" [checked]="selectedFiles.includes(element)"
                    [disabled]="!isFileTypeSupported(element.file_name) || element.file_size > 41943040"></mat-checkbox>
            </mat-cell>
        </ng-container>

        <!-- File Name Column -->
        <ng-container matColumnDef="file_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-file_name"> File Name
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-file_name"> {{element.file_name}} </mat-cell>
        </ng-container>

        <!-- File Size Column -->
        <ng-container matColumnDef="file_size">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-file_size"> Size </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-file_size">
                <ng-container *ngIf="element.file_size != null">
                    {{element.file_size | filesize}}
                </ng-container>
                <ng-container *ngIf="element.file_size == null">
                    N/A
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Owner Email Column -->
        <ng-container matColumnDef="owner_email">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-owner_email"> Owner </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-owner_email">
                {{element.owner_email}}
            </mat-cell>
        </ng-container>

        <!-- Upload Date Column -->
        <ng-container matColumnDef="upload_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-upload_date"> Upload Date
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-upload_date">
                <ng-container *ngIf="element.upload_date != 'None'">
                    {{element.upload_date | date : 'mediumDate'}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Deletion Date Column -->
        <ng-container matColumnDef="deletion_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-deletion_date"> Deletion Date
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-deletion_date">
                <ng-container *ngIf="element.deletion_date != 'None'">
                    {{element.deletion_date | date : 'mediumDate'}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Malware Scan Status Column -->
        <ng-container matColumnDef="malware_scan_status">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-malware_scan_status"> Scan
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-malware_scan_status">
                <ng-container *ngIf="element.malware_scan_status === 'IN_PROGRESS'">
                    <div class="status-container">
                        <mat-icon class="status-icon slow-rotate"
                            matTooltip="Scan in progress. The larger the file, the longer the scan may take."
                            style="color: #1976d2;">autorenew</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'OK'">
                    <div class="status-container">
                        <mat-icon class="status-icon success-icon" matTooltip="No threats detected"
                            style="color: green;">
                            verified_user</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'THREAT'">
                    <div class="status-container">
                        <mat-icon class="status-icon error-icon" matTooltip="Threat detected"
                            style="color: red;">warning
                        </mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'ERROR'">
                    <div class="status-container">
                        <mat-icon class="status-icon error-icon" matTooltip="Scan error"
                            style="color: red;">error</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'SCAN_SKIPPED'">
                    <div class="status-container">
                        <mat-icon class="status-icon warning-icon" matTooltip="File scan unavailable (unsupported format). Please verify file safety before using."
                            style="color: orange;">info</mat-icon>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="!element.malware_scan_status || (element.malware_scan_status !== 'IN_PROGRESS' && element.malware_scan_status !== 'OK' && element.malware_scan_status !== 'THREAT' && element.malware_scan_status !== 'ERROR' && element.malware_scan_status !== 'SCAN_SKIPPED')">
                </ng-container>
            </mat-cell>
        </ng-container>
        <mat-header-row
            *matHeaderRowDef="['select', 'file_name', 'file_size', 'owner_email', 'upload_date', 'deletion_date', 'malware_scan_status']"></mat-header-row>
        <mat-row
            *matRowDef="let row; columns: ['select', 'file_name', 'file_size', 'owner_email', 'upload_date', 'deletion_date', 'malware_scan_status'];"
            [class.disabled-row]="isRowDisabled(row)"
            [matTooltip]="isRowDisabled(row) ? getRowDisabledTooltip(row) : ''" matTooltipPosition="above">
        </mat-row>
    </mat-table>
    <div class="d-flex justify-content-center">
        <div class="spinner-border m-4" role="status" *ngIf="flag_loader_shared"></div>
        <div class="m-4" *ngIf="sharedFilesDataSource.data.length === 0 && !flag_loader_shared">
            No data to show
        </div>
    </div>

    <h5>Your Uploaded Files</h5>
    <i>Maximum file size: 40 MB</i>
    <mat-table #uploadedFilesSort="matSort" [dataSource]="uploadedFilesDataSource" matSort matSortActive="upload_date"
        matSortDirection="desc" class="mat-elevation-z8 uploaded-files-table">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef class="mat-column-select"></mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-select">
                <mat-checkbox (change)="toggleFileSelection(element)" [checked]="selectedFiles.includes(element)"
                    [disabled]="!isFileTypeSupported(element.file_name) || element.file_size > 41943040"></mat-checkbox>
            </mat-cell>
        </ng-container>

        <!-- File Name Column -->
        <ng-container matColumnDef="file_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-file_name"> File Name
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-file_name"> {{element.file_name}} </mat-cell>
        </ng-container>

        <!-- File Size Column -->
        <ng-container matColumnDef="file_size">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-file_size"> Size </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-file_size">
                <ng-container *ngIf="element.file_size != null">
                    {{element.file_size | filesize}}
                </ng-container>
                <ng-container *ngIf="element.file_size == null">
                    N/A
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Upload Date Column -->
        <ng-container matColumnDef="upload_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-upload_date"> Upload Date
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-upload_date">
                <ng-container *ngIf="element.upload_date != 'None'">
                    {{element.upload_date | date : 'mediumDate'}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Deletion Date Column -->
        <ng-container matColumnDef="deletion_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-deletion_date"> Deletion Date
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-deletion_date">
                <ng-container *ngIf="element.deletion_date != 'None'">
                    {{element.deletion_date | date : 'mediumDate'}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Malware Scan Status Column -->
        <ng-container matColumnDef="malware_scan_status">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-malware_scan_status"> Scan
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-column-malware_scan_status">
                <ng-container *ngIf="element.malware_scan_status === 'IN_PROGRESS'">
                    <div class="status-container">
                        <mat-icon class="status-icon slow-rotate"
                            matTooltip="Scan in progress. The larger the file, the longer the scan may take."
                            style="color: #1976d2;">autorenew</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'OK'">
                    <div class="status-container">
                        <mat-icon class="status-icon success-icon" matTooltip="No threats detected"
                            style="color: green;">
                            verified_user</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'THREAT'">
                    <div class="status-container">
                        <mat-icon class="status-icon error-icon" matTooltip="Threat detected"
                            style="color: red;">warning
                        </mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'ERROR'">
                    <div class="status-container">
                        <mat-icon class="status-icon error-icon" matTooltip="Scan error"
                            style="color: red;">error</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'SCAN_SKIPPED'">
                    <div class="status-container">
                        <mat-icon class="status-icon warning-icon" matTooltip="File scan unavailable (unsupported format). Please verify file safety before using."
                            style="color: orange;">info</mat-icon>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="!element.malware_scan_status || (element.malware_scan_status !== 'IN_PROGRESS' && element.malware_scan_status !== 'OK' && element.malware_scan_status !== 'THREAT' && element.malware_scan_status !== 'ERROR' && element.malware_scan_status !== 'SCAN_SKIPPED')">
                </ng-container>
            </mat-cell>
        </ng-container>
        <mat-header-row
            *matHeaderRowDef="['select', 'file_name', 'file_size', 'upload_date', 'deletion_date', 'malware_scan_status']"></mat-header-row>
        <mat-row
            *matRowDef="let row; columns: ['select', 'file_name', 'file_size', 'upload_date', 'deletion_date', 'malware_scan_status'];"
            [class.disabled-row]="isRowDisabled(row)"
            [matTooltip]="isRowDisabled(row) ? getRowDisabledTooltip(row) : ''" matTooltipPosition="above">
        </mat-row>
    </mat-table>
    <div class="d-flex justify-content-center">
        <div class="spinner-border m-4" role="status" *ngIf="flag_loader_uploaded"></div>
        <div class="m-4" *ngIf="uploadedFilesDataSource.data.length === 0 && !flag_loader_uploaded">
            No data to show
        </div>
    </div>

    <div class="translation-controls">
        <mat-form-field>
            <mat-label>Target Language</mat-label>
            <mat-select [(value)]="selectedTargetLanguage">
                <mat-option *ngFor="let language of targetLanguages" [value]="language.code">{{ language.fullName
                    }}</mat-option>
            </mat-select>
        </mat-form-field>

        <button class="vlr-cta-btn vlr-icon-btn" (click)="translateFiles()"
            [disabled]="isTranslateDisabled || !selectedTargetLanguage">
            <mat-icon>translate</mat-icon>
            <span>Translate Files</span>
        </button>
    </div>

    <h5>Translated Files</h5>
    <mat-table #translatedFilesSort="matSort" [dataSource]="translatedFilesDataSource" matSort
        matSortActive="upload_date" matSortDirection="desc" class="mat-elevation-z8">
        <!-- File Name Column -->
        <ng-container matColumnDef="file_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> File Name </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.file_name}} </mat-cell>
        </ng-container>

        <!-- File Size Column -->
        <ng-container matColumnDef="file_size">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Size </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.file_size != null">
                    {{element.file_size | filesize}}
                </ng-container>
                <ng-container *ngIf="element.file_size == null">
                    N/A
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Upload Date Column -->
        <ng-container matColumnDef="upload_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Upload Date </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.upload_date != 'None'">
                    {{element.upload_date | date : 'mediumDate'}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Deletion Date Column -->
        <ng-container matColumnDef="deletion_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Deletion Date </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.deletion_date != 'None'">
                    {{element.deletion_date | date : 'mediumDate'}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- File Size Column -->
        <ng-container matColumnDef="cost">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Cost </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.cost != null">
                    $ {{element.cost}}
                </ng-container>
                <ng-container *ngIf="element.cost == null">
                    N/A
                </ng-container>
            </mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="upload_state">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
            <mat-cell *matCellDef="let element" class="text-center">
                <div class="status-container">
                    <ng-container *ngIf="element.upload_state === 'TRANSLATION_INITIALIZED'">
                        <mat-icon class="status-icon slow-rotate">autorenew</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="element.upload_state === 'TRANSLATION_IN_PROGRESS'">
                        <mat-icon class="status-icon fast-rotate">autorenew</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="element.upload_state === 'SUCCESS'">
                        <mat-icon class="status-icon success-icon">check_circle</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="element.upload_state === 'ERROR'">
                        <mat-icon class="status-icon error-icon" matTooltip="{{element.error_message}}">error</mat-icon>
                    </ng-container>
                    <ng-container
                        *ngIf="element.upload_state !== 'TRANSLATION_INITIALIZED' && element.upload_state !== 'TRANSLATION_IN_PROGRESS' && element.upload_state !== 'SUCCESS' && element.upload_state !== 'ERROR'">
                        {{element.upload_state}}
                    </ng-container>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Download Button Column -->
        <ng-container matColumnDef="download">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
                <button class="vlr-outline-btn vlr-icon-btn" matTooltip="Download translated file"
                    (click)="downloadTranslatedFile(element.object_key, element.file_name)"
                    *ngIf=" element.upload_state=='SUCCESS'" [disabled]="isScanBlocking(element)">
                    <mat-icon fontSet="material-icons-outlined">file_download</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <!-- Malware Scan Status Column -->
        <ng-container matColumnDef="malware_scan_status">
            <mat-header-cell *matHeaderCellDef mat-sort-header 
              matTooltip="All files are automatically scanned for viruses and malicious content. You can only translate or download files that have passed the security check.">
              Scan
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.malware_scan_status === 'IN_PROGRESS'">
                    <div class="status-container">
                        <mat-icon class="status-icon slow-rotate"
                            matTooltip="Scan in progress. The larger the file, the longer the scan may take."
                            style="color: #1976d2;">autorenew</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'OK'">
                    <div class="status-container">
                        <mat-icon class="status-icon success-icon" matTooltip="No threats detected"
                            style="color: green;">
                            verified_user</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'THREAT'">
                    <div class="status-container">
                        <mat-icon class="status-icon error-icon" matTooltip="Threat detected"
                            style="color: red;">warning
                        </mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'ERROR'">
                    <div class="status-container">
                        <mat-icon class="status-icon error-icon" matTooltip="Scan error"
                            style="color: red;">error</mat-icon>
                    </div>
                </ng-container>
                <ng-container *ngIf="element.malware_scan_status === 'SCAN_SKIPPED'">
                    <div class="status-container">
                        <mat-icon class="status-icon warning-icon" matTooltip="File scan unavailable (unsupported format). Please verify file safety before using."
                            style="color: orange;">info</mat-icon>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="!element.malware_scan_status || (element.malware_scan_status !== 'IN_PROGRESS' && element.malware_scan_status !== 'OK' && element.malware_scan_status !== 'THREAT' && element.malware_scan_status !== 'ERROR' && element.malware_scan_status !== 'SCAN_SKIPPED')">
                </ng-container>
            </mat-cell>
        </ng-container>
        <mat-header-row
            *matHeaderRowDef="['file_name', 'file_size', 'upload_date', 'deletion_date', 'cost', 'malware_scan_status', 'upload_state', 'download']"></mat-header-row>
        <mat-row
            *matRowDef="let row; columns: ['file_name', 'file_size', 'upload_date', 'deletion_date', 'cost', 'malware_scan_status', 'upload_state', 'download'];"
            [class.disabled-row]="isRowDisabled(row)"
            [matTooltip]="isRowDisabled(row) ? getRowDisabledTooltip(row) : ''" matTooltipPosition="above">
        </mat-row>
    </mat-table>
    <div class="d-flex justify-content-center">
        <div class="spinner-border m-4" role="status" *ngIf="flag_loader_translated"></div>
        <div class="m-4" *ngIf="translatedFilesDataSource.data.length === 0 && !flag_loader_translated">
            No data to show
        </div>
    </div>
</div>

<style>
    .disabled-row {
        opacity: 0.5;
    }

    .status-container {
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }

    .status-icon {
        transition: opacity 0.5s ease-in-out;
        font-size: 24px;
        /* Ensure icons and spinners have the same size */
    }

    .slow-rotate {
        animation: rotate 2s linear infinite;
    }

    .fast-rotate {
        animation: rotate 1s linear infinite;
    }

    .success-icon {
        color: green;
    }

    .error-icon {
        color: red;
    }

    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>